var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEthereumLogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 115 182",
    focusable: "false",
    className: "chakra-icon css-1io60e2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.5054 181V135.84L1.64064 103.171L57.5054 181Z",
    fill: "#F0CDC2",
    stroke: "#1616B4",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6906 181V135.84L113.555 103.171L57.6906 181Z",
    fill: "#C9B3F5",
    stroke: "#1616B4",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5055 124.615V66.9786L1 92.2811L57.5055 124.615Z",
    fill: "#88AAF1",
    stroke: "#1616B4",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6903 124.615V66.9786L114.196 92.2811L57.6903 124.615Z",
    fill: "#C9B3F5",
    stroke: "#1616B4",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.00006 92.2811L57.5054 1V66.9786L1.00006 92.2811Z",
    fill: "#F0CDC2",
    stroke: "#1616B4",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M114.196 92.2811L57.6906 1V66.9786L114.196 92.2811Z",
    fill: "#B8FAF6",
    stroke: "#1616B4",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereumLogo2);
export default __webpack_public_path__ + "static/media/ethereum-logo2.ede842cfa04d69aa9a30521c193f785f.svg";
export { ForwardRef as ReactComponent };